import { roundedFullClassname } from '@/helpers/environmentHelper';
import {
    selectSelectedXplorSpotWorkspaceTab,
    selectXplorSpotWorkspaceTabs,
    setXplorSpotWorkspaceTabLayout
} from '@/state/reducers/workspaceSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { tabIcon, XplorSpotModules } from '@/utils/hooks/useXplorSpotLayout';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import cn from 'classnames';
import { useMemo } from 'react';
import { IconType } from 'react-icons/lib';
import { updateTree } from 'react-mosaic-component';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { HorizontalScroller } from '../common/HorizontalScroller';

const MobileModuleTabs = () => {
    const screen = useScreenSizes();

    return (
        <div
            className={cn(
                'flex bg-brand-background text-brand-module-title text-xs border-x-[1.5px] border-brand-border p-2'
            )}>
            {(screen.tablet || screen.mobile) && <MobileTabNavigation />}
        </div>
    );
};

export default MobileModuleTabs;

const MobileTabNavigation = () => {
    const dispatch = useAppDispatch();

    const lang = useLanguage();

    const workspaceTabs = useAppSelector(selectXplorSpotWorkspaceTabs);
    const workspaceTab = useAppSelector(selectSelectedXplorSpotWorkspaceTab);

    const workspace = useMemo(() => {
        return workspaceTab || workspaceTabs[0];
    }, [workspaceTabs, workspaceTab]);

    const layout = useMemo(() => {
        if (workspace.layout.mobile) {
            return workspace.layout.mobile as any;
        }
    }, [workspace]);

    const tabs: {
        label: string;
        name: XplorSpotModules;
        title: string;
        Icon: IconType;
    }[] = useMemo(() => {
        return [
            {
                label: 'Order',
                name: 'Order',
                title: lang.locale !== 'en' ? lang.modules.order : 'Order',
                Icon: tabIcon['Order']
            },
            {
                label: 'Prices',
                name: 'Order Book',
                title: lang.locale !== 'en' ? lang.modules['order-book'] : 'Market Depth',
                Icon: tabIcon['Order Book']
            },
            {
                label: 'Chart',
                name: 'Chart',
                title: lang.locale !== 'en' ? lang.modules.chart : 'Chart',
                Icon: tabIcon['Chart']
            },
            {
                label: 'Blotters',
                name: 'Blotter',
                title: lang.locale !== 'en' ? lang.modules.blotter : 'Blotter',
                Icon: tabIcon['Blotter']
            },
            {
                label: 'Balances',
                name: 'Balances',
                title: lang.locale !== 'en' ? lang.modules.balances : 'Balances',
                Icon: tabIcon['Balances']
            }
        ];
    }, [lang]);

    return (
        <HorizontalScroller>
            <div className="flex gap-2">
                {tabs.map(({ name, title, Icon }) => (
                    <div
                        key={name}
                        className={cn(
                            'flex uppercase cursor-pointer whitespace-nowrap text-brand-text font-semibold px-2 py-1.5 rounded-sm gap-2 items-center',
                            {
                                ['bg-brand-accent text-brand-module-title']: layout?.first === name,
                                ['bg-brand-neutral-600 hover:bg-brand-neutral-700']: !(layout?.first === name)
                            },
                            roundedFullClassname
                        )}
                        onClick={() => {
                            switchMobileTab(layout, name, dispatch);
                        }}>
                        <Icon className="w-3.5 h-3.5" />
                        {title}
                    </div>
                ))}
            </div>
        </HorizontalScroller>
        // </div>
    );
};

const switchMobileTab = (mobileLayoutNode, moduleToDrop, dispatch) => {
    let currentNode = mobileLayoutNode;
    if (currentNode) {
        currentNode = updateTree(currentNode, [
            {
                path: [],
                spec: {
                    $set: {
                        direction: 'row',
                        first: moduleToDrop,
                        second: '',
                        splitPercentage: 100
                    }
                }
            }
        ]);
    } else {
        currentNode = moduleToDrop;
    }
    dispatch(
        setXplorSpotWorkspaceTabLayout({
            id: 'current',
            screen: 'mobile',
            layout: currentNode
        })
    );
};
